import axios from 'axios';
class SalutiService {
  getSaluti = (userid) => {
    return axios.get(`http://localhost:8080/api/saluti/${userid}`);
    // 'saluti dal componente js';
  };
  getLogin = () => {
    const qs = require('qs');
    const url = 'https://192.168.1.26:8443/login/';
    return axios.post(
      url,
      qs.stringify({ nome: 'claudio', password: 'manno' })
    );
  };
}

export default new SalutiService();
